import script from "./ExportProfileInputPassword.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExportProfileInputPassword.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__